// src/pages/admin/EstimateCreate.js
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../lib/firebase";
import allocateQuoteNumber from "../../lib/quoteNumbers";

export default function EstimateCreate() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  async function createEstimate(e) {
    e.preventDefault();
    setSaving(true);

    try {
      const estimateNumber = await allocateQuoteNumber("ES");

      const ref = await addDoc(collection(db, "quotes"), {
        docType: "estimate",
        quoteNumber: estimateNumber,
        title: "Estimate",
        status: "draft",
        archived: false,
        clientId: null,
        clientName: "",
        clientOrganization: "",
        clientEmail: "",
        clientPhone: "",
        clientAddress: {
          line1: "",
          line2: "",
          city: "",
          region: "",
          postalCode: "",
          country: "",
        },
        items: [],
        discount: { type: "amount", value: 0 },
        shipping: { type: "amount", value: 0 },
        tax: { type: "percent", value: 0 },
        totals: {
          itemsSubtotal: 0,
          discountAmount: 0,
          shippingAmount: 0,
          preTaxSubtotal: 0,
          taxAmount: 0,
          grandTotal: 0,
        },
        publicMessage: "",
        internalNotes: "",
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      navigate(`/admin/estimates/${ref.id}/edit`);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      <h2 style={{ marginBottom: 6 }}>New Estimate</h2>
      <p className="micro muted">Create a new estimate and start editing.</p>

      <form onSubmit={createEstimate}>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button className="btn primary" disabled={saving}>
            {saving ? "Creating..." : "Create Estimate"}
          </button>
          <Link className="btn" to="/admin/estimates">
            Cancel
          </Link>
        </div>
      </form>
    </div>
  );
}
